// Supported countries with flag, region labels, and postal code labels
export const countries = [
  { code: 'US', name: 'United States', flag: '🇺🇸', regionLabel: 'State', postalLabel: 'Zip Code' },
  { code: 'IN', name: 'India', flag: '🇮🇳', regionLabel: 'State', postalLabel: 'Pincode' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', regionLabel: 'Region', postalLabel: 'Postcode' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', regionLabel: 'Province', postalLabel: 'Postal Code' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', regionLabel: 'State', postalLabel: 'Postcode' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', regionLabel: 'State', postalLabel: 'Postcode' },
  { code: 'FR', name: 'France', flag: '🇫🇷', regionLabel: 'Region', postalLabel: 'Code Postal' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', regionLabel: 'Prefecture', postalLabel: 'Postal Code' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', regionLabel: 'State', postalLabel: 'CEP' },
  { code: 'AE', name: 'UAE', flag: '🇦🇪', regionLabel: 'Emirate', postalLabel: 'Postal Code' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', regionLabel: 'Region', postalLabel: 'Postal Code' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', regionLabel: 'Province', postalLabel: 'Postal Code' },
  { code: 'CN', name: 'China', flag: '🇨🇳', regionLabel: 'Province', postalLabel: 'Postal Code' },
];

// States/provinces/regions by country
export const statesByCountry = {
  'US': null, // uses usStates below
  'IN': [
    { name: 'Andhra Pradesh', code: 'AP' }, { name: 'Arunachal Pradesh', code: 'AR' }, { name: 'Assam', code: 'AS' },
    { name: 'Bihar', code: 'BR' }, { name: 'Chhattisgarh', code: 'CG' }, { name: 'Goa', code: 'GA' },
    { name: 'Gujarat', code: 'GJ' }, { name: 'Haryana', code: 'HR' }, { name: 'Himachal Pradesh', code: 'HP' },
    { name: 'Jharkhand', code: 'JH' }, { name: 'Karnataka', code: 'KA' }, { name: 'Kerala', code: 'KL' },
    { name: 'Madhya Pradesh', code: 'MP' }, { name: 'Maharashtra', code: 'MH' }, { name: 'Manipur', code: 'MN' },
    { name: 'Meghalaya', code: 'ML' }, { name: 'Mizoram', code: 'MZ' }, { name: 'Nagaland', code: 'NL' },
    { name: 'Odisha', code: 'OD' }, { name: 'Punjab', code: 'PB' }, { name: 'Rajasthan', code: 'RJ' },
    { name: 'Sikkim', code: 'SK' }, { name: 'Tamil Nadu', code: 'TN' }, { name: 'Telangana', code: 'TG' },
    { name: 'Tripura', code: 'TR' }, { name: 'Uttar Pradesh', code: 'UP' }, { name: 'Uttarakhand', code: 'UK' },
    { name: 'West Bengal', code: 'WB' }, { name: 'Delhi', code: 'DL' },
  ],
  'GB': [
    { name: 'England', code: 'ENG' }, { name: 'Scotland', code: 'SCT' },
    { name: 'Wales', code: 'WLS' }, { name: 'Northern Ireland', code: 'NIR' },
  ],
  'CA': [
    { name: 'Ontario', code: 'ON' }, { name: 'Quebec', code: 'QC' }, { name: 'British Columbia', code: 'BC' },
    { name: 'Alberta', code: 'AB' }, { name: 'Manitoba', code: 'MB' }, { name: 'Saskatchewan', code: 'SK' },
    { name: 'Nova Scotia', code: 'NS' }, { name: 'New Brunswick', code: 'NB' },
    { name: 'Newfoundland and Labrador', code: 'NL' }, { name: 'Prince Edward Island', code: 'PE' },
  ],
  'AU': [
    { name: 'New South Wales', code: 'NSW' }, { name: 'Victoria', code: 'VIC' },
    { name: 'Queensland', code: 'QLD' }, { name: 'Western Australia', code: 'WA' },
    { name: 'South Australia', code: 'SA' }, { name: 'Tasmania', code: 'TAS' },
    { name: 'Australian Capital Territory', code: 'ACT' }, { name: 'Northern Territory', code: 'NT' },
  ],
  'DE': [
    { name: 'Bavaria', code: 'BY' }, { name: 'Berlin', code: 'BE' }, { name: 'Hamburg', code: 'HH' },
    { name: 'Hesse', code: 'HE' }, { name: 'North Rhine-Westphalia', code: 'NW' },
    { name: 'Baden-Württemberg', code: 'BW' }, { name: 'Lower Saxony', code: 'NI' }, { name: 'Saxony', code: 'SN' },
  ],
  'FR': [
    { name: 'Île-de-France', code: 'IDF' }, { name: 'Provence-Alpes-Côte d\'Azur', code: 'PAC' },
    { name: 'Auvergne-Rhône-Alpes', code: 'ARA' }, { name: 'Occitanie', code: 'OCC' },
    { name: 'Nouvelle-Aquitaine', code: 'NAQ' }, { name: 'Brittany', code: 'BRE' },
    { name: 'Normandy', code: 'NOR' }, { name: 'Grand Est', code: 'GES' },
  ],
  'JP': [
    { name: 'Tokyo', code: 'TK' }, { name: 'Osaka', code: 'OS' }, { name: 'Kyoto', code: 'KT' },
    { name: 'Hokkaido', code: 'HK' }, { name: 'Kanagawa', code: 'KN' }, { name: 'Aichi', code: 'AI' },
    { name: 'Fukuoka', code: 'FK' }, { name: 'Hyogo', code: 'HG' },
  ],
  'BR': [
    { name: 'São Paulo', code: 'SP' }, { name: 'Rio de Janeiro', code: 'RJ' },
    { name: 'Minas Gerais', code: 'MG' }, { name: 'Bahia', code: 'BA' },
    { name: 'Paraná', code: 'PR' }, { name: 'Rio Grande do Sul', code: 'RS' },
    { name: 'Pernambuco', code: 'PE' }, { name: 'Ceará', code: 'CE' },
  ],
  'AE': [
    { name: 'Abu Dhabi', code: 'AZ' }, { name: 'Dubai', code: 'DU' }, { name: 'Sharjah', code: 'SH' },
    { name: 'Ajman', code: 'AJ' }, { name: 'Ras Al Khaimah', code: 'RK' },
    { name: 'Fujairah', code: 'FU' }, { name: 'Umm Al Quwain', code: 'UQ' },
  ],
  'SG': [
    { name: 'Central', code: 'CR' }, { name: 'North', code: 'NR' }, { name: 'North-East', code: 'NE' },
    { name: 'East', code: 'EA' }, { name: 'West', code: 'WE' },
  ],
  'KR': [
    { name: 'Seoul', code: 'SE' }, { name: 'Busan', code: 'BS' }, { name: 'Incheon', code: 'IC' },
    { name: 'Daegu', code: 'DG' }, { name: 'Gyeonggi', code: 'GG' }, { name: 'Jeju', code: 'JJ' },
  ],
  'CN': [
    { name: 'Beijing', code: 'BJ' }, { name: 'Shanghai', code: 'SH' }, { name: 'Guangdong', code: 'GD' },
    { name: 'Zhejiang', code: 'ZJ' }, { name: 'Jiangsu', code: 'JS' }, { name: 'Sichuan', code: 'SC' },
    { name: 'Hubei', code: 'HB' }, { name: 'Hunan', code: 'HN' }, { name: 'Fujian', code: 'FJ' },
    { name: 'Shandong', code: 'SD' }, { name: 'Henan', code: 'HA' }, { name: 'Liaoning', code: 'LN' },
    { name: 'Tianjin', code: 'TJ' }, { name: 'Chongqing', code: 'CQ' }, { name: 'Shaanxi', code: 'SN' },
    { name: 'Yunnan', code: 'YN' }, { name: 'Hebei', code: 'HE' }, { name: 'Anhui', code: 'AH' },
  ],
};

// Cities by state for non-US countries
export const citiesByCountryState = {
  'IN': {
    'AP': ['Hyderabad', 'Visakhapatnam', 'Vijayawada', 'Guntur', 'Tirupati', 'Rajahmundry'],
    'KA': ['Bengaluru', 'Mysuru', 'Hubli', 'Mangaluru', 'Belgaum', 'Dharwad'],
    'MH': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Navi Mumbai'],
    'TN': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Erode'],
    'TG': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam'],
    'DL': ['New Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi'],
    'KL': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam'],
    'GJ': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar'],
    'RJ': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner'],
    'UP': ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Prayagraj', 'Noida', 'Ghaziabad'],
    'WB': ['Kolkata', 'Howrah', 'Durgapur', 'Siliguri', 'Asansol'],
    'PB': ['Chandigarh', 'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala'],
    'HR': ['Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Karnal', 'Hisar'],
    'BR': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Darbhanga'],
    'GA': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda'],
    'AS': ['Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Tezpur'],
    'HP': ['Shimla', 'Manali', 'Dharamshala', 'Kullu', 'Solan'],
    'UK': ['Dehradun', 'Haridwar', 'Rishikesh', 'Nainital', 'Mussoorie'],
    'JH': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh'],
    'CG': ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg'],
    'OD': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Puri', 'Berhampur'],
    'MP': ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain'],
    'SK': ['Gangtok', 'Namchi', 'Gyalshing', 'Mangan'],
    'MN': ['Imphal', 'Bishnupur', 'Thoubal', 'Churachandpur'],
    'ML': ['Shillong', 'Tura', 'Jowai', 'Nongstoin'],
    'MZ': ['Aizawl', 'Lunglei', 'Champhai', 'Serchhip'],
    'NL': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang'],
    'TR': ['Agartala', 'Udaipur', 'Dharmanagar', 'Kailashahar'],
    'AR': ['Itanagar', 'Naharlagun', 'Pasighat', 'Tawang'],
  },
  'GB': {
    'ENG': ['London', 'Manchester', 'Birmingham', 'Liverpool', 'Leeds', 'Bristol', 'Sheffield', 'Newcastle', 'Nottingham', 'Cambridge', 'Oxford', 'Brighton', 'Bath', 'York'],
    'SCT': ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness', 'St Andrews', 'Stirling'],
    'WLS': ['Cardiff', 'Swansea', 'Newport', 'Bangor', 'Wrexham'],
    'NIR': ['Belfast', 'Derry', 'Lisburn', 'Newry', 'Bangor'],
  },
  'CA': {
    'ON': ['Toronto', 'Ottawa', 'Mississauga', 'Hamilton', 'London', 'Brampton', 'Kitchener', 'Windsor', 'Markham'],
    'QC': ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke'],
    'BC': ['Vancouver', 'Victoria', 'Surrey', 'Burnaby', 'Richmond', 'Kelowna', 'Kamloops'],
    'AB': ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'St. Albert', 'Medicine Hat'],
    'MB': ['Winnipeg', 'Brandon', 'Steinbach', 'Thompson', 'Portage la Prairie'],
    'SK': ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw', 'Swift Current'],
    'NS': ['Halifax', 'Dartmouth', 'Sydney', 'Truro', 'New Glasgow'],
    'NB': ['Moncton', 'Saint John', 'Fredericton', 'Dieppe', 'Miramichi'],
    'NL': ['St. John\'s', 'Mount Pearl', 'Corner Brook', 'Conception Bay South'],
    'PE': ['Charlottetown', 'Summerside', 'Stratford', 'Cornwall'],
  },
  'AU': {
    'NSW': ['Sydney', 'Newcastle', 'Wollongong', 'Central Coast', 'Coffs Harbour'],
    'VIC': ['Melbourne', 'Geelong', 'Ballarat', 'Bendigo', 'Shepparton'],
    'QLD': ['Brisbane', 'Gold Coast', 'Sunshine Coast', 'Cairns', 'Townsville', 'Toowoomba'],
    'WA': ['Perth', 'Fremantle', 'Mandurah', 'Bunbury', 'Geraldton'],
    'SA': ['Adelaide', 'Mount Gambier', 'Whyalla', 'Murray Bridge'],
    'TAS': ['Hobart', 'Launceston', 'Devonport', 'Burnie'],
    'ACT': ['Canberra', 'Belconnen', 'Tuggeranong', 'Woden Valley'],
    'NT': ['Darwin', 'Alice Springs', 'Palmerston', 'Katherine'],
  },
  'DE': {
    'BY': ['Munich', 'Nuremberg', 'Augsburg', 'Regensburg', 'Würzburg'],
    'BE': ['Berlin'],
    'HH': ['Hamburg'],
    'HE': ['Frankfurt', 'Wiesbaden', 'Kassel', 'Darmstadt', 'Offenbach'],
    'NW': ['Cologne', 'Düsseldorf', 'Dortmund', 'Essen', 'Bonn', 'Münster'],
    'BW': ['Stuttgart', 'Karlsruhe', 'Mannheim', 'Freiburg', 'Heidelberg'],
    'NI': ['Hanover', 'Braunschweig', 'Oldenburg', 'Osnabrück', 'Göttingen'],
    'SN': ['Dresden', 'Leipzig', 'Chemnitz', 'Zwickau'],
  },
  'FR': {
    'IDF': ['Paris', 'Boulogne-Billancourt', 'Saint-Denis', 'Versailles', 'Nanterre'],
    'PAC': ['Marseille', 'Nice', 'Toulon', 'Aix-en-Provence', 'Cannes'],
    'ARA': ['Lyon', 'Grenoble', 'Saint-Étienne', 'Clermont-Ferrand'],
    'OCC': ['Toulouse', 'Montpellier', 'Nîmes', 'Perpignan'],
    'NAQ': ['Bordeaux', 'Limoges', 'Poitiers', 'La Rochelle'],
    'BRE': ['Rennes', 'Brest', 'Quimper', 'Saint-Malo'],
    'NOR': ['Rouen', 'Le Havre', 'Caen', 'Cherbourg'],
    'GES': ['Strasbourg', 'Reims', 'Metz', 'Mulhouse', 'Nancy'],
  },
  'JP': {
    'TK': ['Tokyo', 'Shibuya', 'Shinjuku', 'Minato', 'Chiyoda'],
    'OS': ['Osaka', 'Sakai', 'Higashiosaka', 'Toyonaka'],
    'KT': ['Kyoto', 'Uji', 'Kameoka'],
    'HK': ['Sapporo', 'Asahikawa', 'Hakodate', 'Obihiro'],
    'KN': ['Yokohama', 'Kawasaki', 'Sagamihara', 'Fujisawa'],
    'AI': ['Nagoya', 'Toyota', 'Okazaki', 'Toyohashi'],
    'FK': ['Fukuoka', 'Kitakyushu', 'Kurume', 'Omuta'],
    'HG': ['Kobe', 'Himeji', 'Nishinomiya', 'Amagasaki'],
  },
  'BR': {
    'SP': ['São Paulo', 'Campinas', 'Santos', 'São José dos Campos', 'Ribeirão Preto'],
    'RJ': ['Rio de Janeiro', 'Niterói', 'Duque de Caxias', 'Nova Iguaçu'],
    'MG': ['Belo Horizonte', 'Uberlândia', 'Juiz de Fora', 'Contagem'],
    'BA': ['Salvador', 'Feira de Santana', 'Vitória da Conquista'],
    'PR': ['Curitiba', 'Londrina', 'Maringá', 'Foz do Iguaçu'],
    'RS': ['Porto Alegre', 'Caxias do Sul', 'Pelotas', 'Canoas'],
    'PE': ['Recife', 'Olinda', 'Jaboatão dos Guararapes', 'Caruaru'],
    'CE': ['Fortaleza', 'Juazeiro do Norte', 'Sobral', 'Caucaia'],
  },
  'AE': {
    'AZ': ['Abu Dhabi', 'Al Ain', 'Madinat Zayed'],
    'DU': ['Dubai', 'Jebel Ali', 'Hatta'],
    'SH': ['Sharjah', 'Khor Fakkan', 'Kalba'],
    'AJ': ['Ajman'],
    'RK': ['Ras Al Khaimah'],
    'FU': ['Fujairah', 'Dibba Al-Fujairah'],
    'UQ': ['Umm Al Quwain'],
  },
  'SG': {
    'CR': ['Orchard', 'Marina Bay', 'Tanjong Pagar', 'Chinatown', 'Bugis'],
    'NR': ['Woodlands', 'Sembawang', 'Yishun', 'Admiralty'],
    'NE': ['Serangoon', 'Hougang', 'Punggol', 'Sengkang'],
    'EA': ['Tampines', 'Bedok', 'Pasir Ris', 'Changi'],
    'WE': ['Jurong', 'Clementi', 'Bukit Batok', 'Bukit Panjang'],
  },
  'KR': {
    'SE': ['Seoul', 'Gangnam', 'Hongdae', 'Itaewon', 'Myeongdong'],
    'BS': ['Busan', 'Haeundae', 'Seomyeon', 'Nampo'],
    'IC': ['Incheon', 'Songdo', 'Bupyeong'],
    'DG': ['Daegu', 'Suseong', 'Dalseong'],
    'GG': ['Suwon', 'Seongnam', 'Goyang', 'Yongin', 'Bucheon'],
    'JJ': ['Jeju City', 'Seogwipo'],
  },
  'CN': {
    'BJ': ['Beijing', 'Haidian', 'Chaoyang', 'Dongcheng', 'Xicheng'],
    'SH': ['Shanghai', 'Pudong', 'Jing\'an', 'Huangpu', 'Minhang'],
    'GD': ['Guangzhou', 'Shenzhen', 'Dongguan', 'Foshan', 'Zhuhai', 'Zhongshan'],
    'ZJ': ['Hangzhou', 'Ningbo', 'Wenzhou', 'Shaoxing', 'Jiaxing'],
    'JS': ['Nanjing', 'Suzhou', 'Wuxi', 'Changzhou', 'Nantong'],
    'SC': ['Chengdu', 'Mianyang', 'Deyang', 'Leshan', 'Yibin'],
    'HB': ['Wuhan', 'Yichang', 'Xiangyang', 'Huangshi', 'Jingzhou'],
    'HN': ['Changsha', 'Zhuzhou', 'Xiangtan', 'Hengyang', 'Yueyang'],
    'FJ': ['Fuzhou', 'Xiamen', 'Quanzhou', 'Zhangzhou', 'Putian'],
    'SD': ['Jinan', 'Qingdao', 'Yantai', 'Weihai', 'Zibo'],
    'HA': ['Zhengzhou', 'Luoyang', 'Kaifeng', 'Nanyang', 'Xinxiang'],
    'LN': ['Shenyang', 'Dalian', 'Anshan', 'Fushun', 'Jinzhou'],
    'TJ': ['Tianjin', 'Binhai', 'Nankai', 'Hexi'],
    'CQ': ['Chongqing', 'Yuzhong', 'Jiangbei', 'Shapingba'],
    'SN': ['Xi\'an', 'Xianyang', 'Baoji', 'Weinan', 'Yan\'an'],
    'YN': ['Kunming', 'Dali', 'Lijiang', 'Yuxi', 'Qujing'],
    'HE': ['Shijiazhuang', 'Tangshan', 'Baoding', 'Handan', 'Langfang'],
    'AH': ['Hefei', 'Wuhu', 'Bengbu', 'Anqing', 'Ma\'anshan'],
  },
};

// US States with major cities
export const usStates = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' }
];

// Cities by state (major cities for each state)
export const citiesByState = {
  'AL': ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'],
  'AK': ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Wasilla'],
  'AZ': ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale', 'Tempe'],
  'AR': ['Little Rock', 'Fayetteville', 'Fort Smith', 'Jonesboro', 'North Little Rock'],
  'CA': ['Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno', 'Sacramento', 'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim', 'Santa Ana', 'Riverside', 'Stockton', 'Irvine', 'Chula Vista', 'Fremont', 'San Bernardino', 'Modesto', 'Fontana', 'Oxnard'],
  'CO': ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Thornton', 'Arvada', 'Westminster', 'Pueblo', 'Centennial'],
  'CT': ['Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury', 'Norwalk', 'Danbury', 'New Britain', 'West Hartford', 'Greenwich'],
  'DE': ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
  'FL': ['Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg', 'Hialeah', 'Tallahassee', 'Fort Lauderdale', 'Port St. Lucie', 'Cape Coral', 'Pembroke Pines', 'Hollywood', 'Miramar', 'Gainesville', 'Coral Springs', 'Miami Gardens', 'Clearwater', 'Palm Bay', 'West Palm Beach', 'Pompano Beach'],
  'GA': ['Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens', 'Sandy Springs', 'Roswell', 'Macon', 'Johns Creek', 'Albany'],
  'HI': ['Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Kaneohe'],
  'ID': ['Boise', 'Nampa', 'Meridian', 'Idaho Falls', 'Pocatello'],
  'IL': ['Chicago', 'Aurora', 'Rockford', 'Joliet', 'Naperville', 'Springfield', 'Peoria', 'Elgin', 'Waukegan', 'Cicero', 'Champaign', 'Bloomington', 'Arlington Heights', 'Evanston', 'Schaumburg'],
  'IN': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers', 'Bloomington', 'Hammond', 'Gary', 'Muncie'],
  'IA': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City', 'Waterloo', 'Council Bluffs', 'Ames', 'West Des Moines', 'Dubuque'],
  'KS': ['Wichita', 'Overland Park', 'Kansas City', 'Olathe', 'Topeka', 'Lawrence', 'Shawnee', 'Manhattan', 'Lenexa', 'Salina'],
  'KY': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington', 'Hopkinsville', 'Richmond', 'Florence', 'Georgetown', 'Henderson'],
  'LA': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles', 'Kenner', 'Bossier City', 'Monroe', 'Alexandria', 'Houma'],
  'ME': ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn', 'Biddeford', 'Sanford', 'Saco', 'Augusta', 'Westbrook'],
  'MD': ['Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie', 'Annapolis', 'College Park', 'Salisbury', 'Laurel', 'Greenbelt'],
  'MA': ['Boston', 'Worcester', 'Springfield', 'Lowell', 'Cambridge', 'New Bedford', 'Brockton', 'Quincy', 'Lynn', 'Fall River', 'Newton', 'Lawrence', 'Somerville', 'Framingham', 'Haverhill', 'Waltham', 'Malden', 'Brookline', 'Plymouth', 'Medford'],
  'MI': ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Lansing', 'Ann Arbor', 'Flint', 'Dearborn', 'Livonia', 'Troy'],
  'MN': ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington', 'Brooklyn Park', 'Plymouth', 'St. Cloud', 'Eagan', 'Woodbury'],
  'MS': ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi', 'Meridian', 'Tupelo', 'Greenville', 'Olive Branch', 'Horn Lake'],
  'MO': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence', 'Lee\'s Summit', 'O\'Fallon', 'St. Joseph', 'St. Charles', 'St. Peters'],
  'MT': ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte', 'Helena', 'Kalispell', 'Havre', 'Anaconda', 'Miles City'],
  'NE': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney', 'Fremont', 'Hastings', 'North Platte', 'Norfolk', 'Columbus'],
  'NV': ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks', 'Carson City', 'Fernley', 'Elko', 'Mesquite', 'Boulder City'],
  'NH': ['Manchester', 'Nashua', 'Concord', 'Derry', 'Rochester', 'Dover', 'Salem', 'Merrimack', 'Londonderry', 'Hudson'],
  'NJ': ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Woodbridge', 'Lakewood', 'Toms River', 'Hamilton', 'Trenton'],
  'NM': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell', 'Farmington', 'Clovis', 'Hobbs', 'Alamogordo', 'Carlsbad'],
  'NY': ['New York City', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'New Rochelle', 'Mount Vernon', 'Schenectady', 'Utica', 'White Plains', 'Hempstead', 'Troy', 'Niagara Falls', 'Binghamton'],
  'NC': ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville', 'Cary', 'Wilmington', 'High Point', 'Concord'],
  'ND': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo', 'Williston', 'Dickinson', 'Mandan', 'Jamestown', 'Wahpeton'],
  'OH': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma', 'Canton', 'Youngstown', 'Lorain'],
  'OK': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton', 'Edmond', 'Moore', 'Midwest City', 'Enid', 'Stillwater'],
  'OR': ['Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro', 'Bend', 'Beaverton', 'Medford', 'Springfield', 'Corvallis'],
  'PA': ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Bethlehem', 'Lancaster', 'Harrisburg', 'Altoona'],
  'RI': ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence', 'Woonsocket', 'Newport', 'Central Falls', 'Westerly', 'Cumberland'],
  'SC': ['Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill', 'Greenville', 'Summerville', 'Sumter', 'Hilton Head Island', 'Spartanburg'],
  'SD': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown', 'Mitchell', 'Yankton', 'Pierre', 'Huron', 'Vermillion'],
  'TN': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville', 'Murfreesboro', 'Franklin', 'Jackson', 'Johnson City', 'Bartlett'],
  'TX': ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo', 'Lubbock', 'Garland', 'Irving', 'Amarillo', 'Grand Prairie', 'Brownsville', 'McKinney', 'Frisco', 'Pasadena', 'Killeen'],
  'UT': ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem', 'Sandy', 'Ogden', 'St. George', 'Layton', 'Taylorsville'],
  'VT': ['Burlington', 'Essex', 'South Burlington', 'Colchester', 'Rutland', 'Montpelier', 'Barre', 'St. Albans', 'Milton', 'Brattleboro'],
  'VA': ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News', 'Alexandria', 'Hampton', 'Portsmouth', 'Suffolk', 'Roanoke'],
  'WA': ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Kent', 'Everett', 'Renton', 'Yakima', 'Federal Way', 'Spokane Valley', 'Bellingham', 'Kennewick', 'Auburn', 'Pasco'],
  'WV': ['Charleston', 'Huntington', 'Parkersburg', 'Morgantown', 'Wheeling', 'Martinsburg', 'Fairmont', 'Beckley', 'Clarksburg', 'South Charleston'],
  'WI': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton', 'Oshkosh', 'Eau Claire', 'Janesville', 'West Allis'],
  'WY': ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs', 'Sheridan', 'Green River', 'Evanston', 'Riverton', 'Jackson']
};

// Areas/Neighborhoods by city (Seattle with comprehensive neighborhoods and zip codes)
export const areasByCity = {
  'Seattle': [
    // Downtown & Central
    'Downtown', 'Belltown', 'Pioneer Square', 'International District', 'First Hill', 'Denny Triangle',
    'South Lake Union', 'Cascade', 'Eastlake', 'Portage Bay',
    
    // Capitol Hill & Central District
    'Capitol Hill', 'Central District', 'Madison Park', 'Madrona', 'Leschi', 'Montlake',
    'Denny Blaine', 'Miller Park', 'Harrison/Denny-Blaine',
    
    // North Seattle
    'University District', 'Ravenna', 'Laurelhurst', 'Windermere', 'Sand Point', 'Wedgwood',
    'View Ridge', 'Bryant', 'Roosevelt', 'Maple Leaf', 'Northgate', 'Lake City',
    'Bitter Lake', 'Licton Springs', 'Aurora', 'Broadview', 'Blue Ridge', 'Carkeek',
    'Haller Lake', 'Meadowbrook', 'Olympic Hills', 'Pinehurst',
    
    // Northwest Seattle
    'Queen Anne', 'Magnolia', 'Interbay', 'Fremont', 'Wallingford', 'Phinney Ridge',
    'Greenwood', 'Crown Hill', 'Sunset Hill', 'Loyal Heights', 'Ballard', 'Green Lake',
    'Fremont', 'Wallingford', 'Phinney Ridge',
    
    // West Seattle
    'West Seattle', 'Alki', 'Admiral', 'Genesee', 'Highland Park', 'Roxhill',
    'Delridge', 'High Point', 'White Center', 'South Park', 'Seaview', 'Arbor Heights',
    'Fauntleroy', 'Gatewood', 'Morgan Junction',
    
    // South Seattle
    'Beacon Hill', 'Georgetown', 'SoDo', 'Industrial District', 'Mount Baker',
    'Columbia City', 'Rainier Valley', 'Rainier Beach', 'Othello', 'Brighton',
    'Dunlap', 'New Holly', 'Holly Park', 'Seward Park', 'Judkins Park',
    'Atlantic', 'North Beacon Hill', 'South Beacon Hill'
  ],
  'Boston': ['Downtown', 'Back Bay', 'Beacon Hill', 'North End', 'South End', 'Fenway', 'Allston', 'Brighton', 'Cambridge', 'Somerville'],
  'New York City': ['Manhattan', 'Brooklyn', 'Queens', 'Bronx', 'Staten Island', 'Upper East Side', 'Upper West Side', 'Greenwich Village', 'SoHo', 'Tribeca'],
  'Los Angeles': ['Downtown LA', 'Hollywood', 'Beverly Hills', 'Santa Monica', 'Venice', 'Westwood', 'Pasadena', 'Glendale', 'Burbank', 'Long Beach'],
  'Chicago': ['Downtown', 'Lincoln Park', 'Wicker Park', 'Lakeview', 'River North', 'Gold Coast', 'Old Town', 'Hyde Park', 'Evanston', 'Oak Park'],
  'San Francisco': ['Downtown', 'Mission District', 'Castro', 'Haight-Ashbury', 'North Beach', 'Chinatown', 'Financial District', 'Marina', 'Pacific Heights', 'SOMA'],
  'Austin': ['Downtown', 'South Austin', 'East Austin', 'West Campus', 'North Austin', 'South Lamar', 'Hyde Park', 'Zilker', 'Barton Hills', 'Clarksville'],
  'Denver': ['Downtown', 'Capitol Hill', 'Highlands', 'LoDo', 'Cherry Creek', 'Five Points', 'RiNo', 'Washington Park', 'Platt Park', 'Park Hill'],
  'Portland': ['Downtown', 'Pearl District', 'Alberta Arts', 'Hawthorne', 'Sellwood', 'Northeast', 'Southeast', 'North Portland', 'Beaverton', 'Lake Oswego'],
  'Miami': ['Downtown', 'South Beach', 'Brickell', 'Wynwood', 'Coconut Grove', 'Little Havana', 'Coral Gables', 'Aventura', 'Key Biscayne', 'Design District']
};

// Default areas for cities not in the list
export const getDefaultAreas = (city) => {
  return ['Downtown', 'North', 'South', 'East', 'West', 'Central', 'Campus', 'Historic District', 'Waterfront', 'Suburbs'];
};

// Pincodes (ZIP codes) - Comprehensive Seattle zip codes by neighborhood
export const pincodesByArea = {
  // Downtown & Central
  'Downtown': ['98101', '98104', '98121'],
  'Belltown': ['98121'],
  'Pioneer Square': ['98104'],
  'International District': ['98104'],
  'First Hill': ['98104', '98122'],
  'Denny Triangle': ['98101', '98121'],
  'South Lake Union': ['98109'],
  'Cascade': ['98109'],
  'Eastlake': ['98102'],
  'Portage Bay': ['98102'],
  
  // Capitol Hill & Central District
  'Capitol Hill': ['98102', '98112', '98122'],
  'Central District': ['98122', '98144'],
  'Madison Park': ['98112'],
  'Madrona': ['98122'],
  'Leschi': ['98122'],
  'Montlake': ['98112', '98195'],
  'Denny Blaine': ['98122'],
  'Miller Park': ['98122'],
  'Harrison/Denny-Blaine': ['98122'],
  
  // North Seattle
  'University District': ['98105', '98115', '98195'],
  'Ravenna': ['98105', '98115'],
  'Laurelhurst': ['98105'],
  'Windermere': ['98105'],
  'Sand Point': ['98105'],
  'Wedgwood': ['98115'],
  'View Ridge': ['98115'],
  'Bryant': ['98105'],
  'Roosevelt': ['98105', '98115'],
  'Maple Leaf': ['98115'],
  'Northgate': ['98125', '98133'],
  'Lake City': ['98125', '98115'],
  'Bitter Lake': ['98133'],
  'Licton Springs': ['98103'],
  'Aurora': ['98133'],
  'Broadview': ['98177'],
  'Blue Ridge': ['98177'],
  'Carkeek': ['98177'],
  'Haller Lake': ['98133'],
  'Meadowbrook': ['98125'],
  'Olympic Hills': ['98125'],
  'Pinehurst': ['98125'],
  
  // Northwest Seattle
  'Queen Anne': ['98109', '98119', '98199'],
  'Magnolia': ['98199'],
  'Interbay': ['98119'],
  'Fremont': ['98103'],
  'Wallingford': ['98103'],
  'Phinney Ridge': ['98103'],
  'Greenwood': ['98103', '98117'],
  'Crown Hill': ['98117'],
  'Sunset Hill': ['98117'],
  'Loyal Heights': ['98117'],
  'Ballard': ['98107', '98117'],
  'Green Lake': ['98103', '98115'],
  
  // West Seattle
  'West Seattle': ['98116', '98126', '98136', '98146'],
  'Alki': ['98116'],
  'Admiral': ['98116'],
  'Genesee': ['98116'],
  'Highland Park': ['98126'],
  'Roxhill': ['98126'],
  'Delridge': ['98126', '98136'],
  'High Point': ['98126'],
  'White Center': ['98146'],
  'South Park': ['98108'],
  'Seaview': ['98136'],
  'Arbor Heights': ['98136'],
  'Fauntleroy': ['98136'],
  'Gatewood': ['98136'],
  'Morgan Junction': ['98126'],
  
  // South Seattle
  'Beacon Hill': ['98108', '98144'],
  'Georgetown': ['98108'],
  'SoDo': ['98134', '98108'],
  'Industrial District': ['98134', '98108'],
  'Mount Baker': ['98144'],
  'Columbia City': ['98118', '98144'],
  'Rainier Valley': ['98118', '98144'],
  'Rainier Beach': ['98118'],
  'Othello': ['98118'],
  'Brighton': ['98118'],
  'Dunlap': ['98118'],
  'New Holly': ['98118'],
  'Holly Park': ['98118'],
  'Seward Park': ['98118'],
  'Judkins Park': ['98144'],
  'Atlantic': ['98144'],
  'North Beacon Hill': ['98108'],
  'South Beacon Hill': ['98108', '98144']
};

// Default pincodes for areas not in the list
export const getDefaultPincodes = (area) => {
  return ['00000', '00001', '00002', '00003', '00004'];
};

